<template>
  <dl>
    <template v-for="group in checkList.group">
      <dt>{{group.category}}</dt>
      <dd  v-for="(question, key) in group.questions">
        <md-checkbox
          class="md-primary"
          v-model="checkList.answers[key]"
          @change="changedCheckbox(key, checkList.answers[key])"
        >
          {{question}}
        </md-checkbox>
      </dd>
    </template>
  </dl>
</template>

<script>
  export default {
    name: 'CheckTable',
    props: {
      checkList: {},
    },
    methods: {
      changedCheckbox(key, answer) {
        this.$emit('changedCheckbox', key, answer);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/parts/CheckTable.vue?ed8405be